// Canonical participant-facing help guide URLs. Kept in one place so every
// surface links to the same destination without duplicating the URL.
export const HELP_NOTIFICATIONS_URL = 'https://looklook.app/help/notifications/'
